import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    -webkit-box-align: center;
    -webkit-box-pack: center;
    justify-self: center;
    align-self: center;
    width: 84%;

    /* Responsive */
    @media (max-width: 1024px) {
        padding: ${props => (!!props.hasData ? "15px" : "0")};
    }
    @media (max-width: 768px) {
        padding: ${props => (!!props.hasData ? "10px" : "0")};
    }
    @media (max-width: 480px) {
        padding: ${props => (!!props.hasData ? "5px" : "0")};
    }


`;

export const TitleContainer = styled.div`
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1d2126;
`;

export const GalleryGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 16px;
    width: 100%;
`;

export const GalleryImage = styled.img`
    width: 100%;
    height: 220px;
    object-fit: cover;
    cursor: pointer;
    border-radius: 8px;
    transition: transform 0.25s ease, box-shadow 0.25s ease;

    &:hover {
        transform: scale(1.03);
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    }
`;
